import CartIcon from "~/assets/icons/CartIcon"
import Logo from "~/assets/icons/Logo"
import CartBadge from "~/rs-components/global/header/CartBadge.client"
import { CustomerMetafields } from "~/types"
import IconMenu from "../custom_icons/menuIcon"
import UserIcon from "~/assets/icons/UserIcon"
import TrustPilotManagement from "~/rs-components/home/TrustPilotManagement.client"
import { trustPilotCustomSetting, trustPilotTop } from "../settings"
import { isNonTransactional } from "../settings/__nonTransactional"
import { isKiosk } from "../settings/__product"
import TrustPilotCustom from "./TrustPilotCustom.client"
import SearchIcon from "~/assets/icons/SearchIcon"
import LoginIcon from "../assets/login"
import BasketIcon from "../assets/basket"
import StoresIcon from "../assets/stores"

type SetupMobileHeaderProps = {
    openMenu: () => void,
    openCart: () => void,
    customer?: CustomerMetafields,
}

export default function SetupMobileHeader({ openMenu, openCart, customer }: SetupMobileHeaderProps) {
    return (
        <>
            <div className="NotificationPromo">
                <div className="NotificationPromo__container">
                    <div className="NotificationPromo__text">
                        <p>We are the highest rated sofa company in the UK!  <span><a href="/news/kc-sofas-highest-rated-sofa-company-in-the-uk-1"> Click here</a> to find out more.</span></p>
                    </div>
                </div>
            </div>


            <div className="headerWrapper">

                <div className="headerResponsive__menuArea flex items-center justify-start w-full">
                    <button onClick={openMenu} className="relative flex items-center justify-center w-8 h-8">
                        <IconMenu />
                    </button>
                    <a href="/page/store-locator" className="iconItem lineRight">
                        <StoresIcon></StoresIcon>
                        Stores
                    </a>
                </div>

                <span
                    className="headerResponsive__logoArea flex items-center self-stretch leading-[3rem] md:leading-[4rem] justify-center flex-grow w-full h-full">
                    <a href="/">
                        <img className="logoMobile" src="https://cdn.shopify.com/s/files/1/0625/0240/4246/files/logoKc.svg?v=1723741188"  alt="" />
                    </a>
                </span>

                <div className="headerResponsive__cartArea flex items-center justify-end w-full gap-4">
                    <a href="/account" className="iconItem lineRight one">
                        <LoginIcon></LoginIcon>
                        LogIn
                    </a>
                    <div className="cartArea  lineRight">
                        {!isNonTransactional &&
                            <button onClick={openCart} className='cartIcon relative flex items-center justify-center w-8 h-8'>
                                <div className="basket">
                                    <BasketIcon />
                                    <CartBadge />
                                </div>
                                <p>Basket</p>
                            </button>}

                    </div>
                </div>

            </div>


        </>
    )
}